import React, { useEffect, useState } from "react";
import { reviewsByPage } from "./reviewsByPage";
import "./CcgPremiumReviews.css";

const recentQuoteSignals = [
  "Recent quote checked: Ealing W5 -> Heathrow",
  "Recent quote checked: Heathrow -> Croydon CR0",
  "Recent quote checked: Camden WC1 -> Gatwick",
  "Recent quote checked: Luton -> Hammersmith W6",
  "Recent quote checked: Windsor Castle -> Heathrow",
  "Recent quote checked: Legoland -> Slough SL1",
];

const trustSignals = [
  {
    type: "coverage",
    label: "Coverage",
    text: "10+ partner drivers around Heathrow and Gatwick",
    proof: "Licensed drivers",
  },
  ...recentQuoteSignals.map((text) => ({
    type: "recentQuote",
    label: "Recent quote",
    text,
    proof: "Live quote and booking",
  })),
  {
    type: "routeDemand",
    label: "Popular today",
    text: "Heathrow T2-T5, Gatwick South, then Luton and Stansted",
    proof: "Live airport tracking",
  },
  {
    type: "themePark",
    label: "Family routes",
    text: "Legoland, Thorpe Park and Windsor Castle",
    proof: "Live attraction coverage",
  },
  {
    type: "support",
    label: "Support online",
    text: "Need help with luggage, child seats or timings?",
    action: "Open chat",
  },
];

function buildFeed(reviews = []) {
  const reviewItems = reviews.map((review) => ({ type: "review", review }));
  if (!reviewItems.length) return trustSignals;

  const feed = [];
  const max = Math.max(reviewItems.length, trustSignals.length);
  for (let i = 0; i < max; i += 1) {
    if (reviewItems[i % reviewItems.length]) feed.push(reviewItems[i % reviewItems.length]);
    if (trustSignals[i % trustSignals.length]) feed.push(trustSignals[i % trustSignals.length]);
  }
  return feed;
}

function openSupportChat() {
  if (typeof window === "undefined") return;
  const launcher = document.querySelector(".floating-support:not(.floating-support-open) .floating-support-launcher");
  if (launcher) {
    launcher.click();
    return;
  }
  window.dispatchEvent(new CustomEvent("ccg:open-support-chat", { detail: { flow: "enquiry" } }));
}

const CcgPremiumReviews = ({
  pageKey = "/",
  ariaLabel = "Customer reviews",
  intervalMs = 4200,
  reviewsOverride,
}) => {
  const reviews = reviewsOverride || reviewsByPage[pageKey] || reviewsByPage.default || [];
  const feed = buildFeed(reviews);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [pageKey]);

  useEffect(() => {
    if (feed.length <= 1) return undefined;
    const timer = setInterval(() => {
      setIndex((current) => (current + 1) % feed.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [feed.length, intervalMs]);

  if (!feed.length) return null;
  const item = feed[index % feed.length];
  const review = item.review;

  return (
    <section className="ccg-premium-reviews" aria-label={ariaLabel}>
      <div className="ccg-premium-review-track" key={index}>
        <article className={`ccg-premium-review-card is-${item.type}`} key={`${item.type}-${review?.name || item.label}-${index}`}>
          {item.type === "review" ? (
            <>
              <span className="ccg-premium-review-rating">
                4.8 ★★★★★{" "}
                <small>Google reviews</small>
              </span>
              <p>“{review.text}”</p>
              <strong>- {review.name}</strong>
            </>
          ) : (
            <>
              <span className="ccg-premium-trust-label">
                <i aria-hidden="true" />
                <small>{item.label}</small>
              </span>
              <p>{item.text}</p>
              {item.action ? (
                <button type="button" onClick={openSupportChat}>{item.action}</button>
              ) : (
                <strong>{item.proof}</strong>
              )}
            </>
          )}
        </article>
      </div>
    </section>
  );
};

export default CcgPremiumReviews;
